import React, {Dispatch, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom'

import {Flow, FlowFetchResponse} from '../_services/Flow';
import {User} from '../_services/User'
import {LoginForm, LoginFormValues} from '../components/LoginForm';
import {userAuthenticated} from '../_actions/user';

// @ts-ignore
import AppLogo from '../_assets/images/gravityflow-icon-blue.svg';
import {ActivityButton} from '../components/ActivityButton';

type LoginPageProps = {
    dispatchUserAuthenticated: () => void;
};

const Login: React.FunctionComponent<LoginPageProps> = ({
                                                            dispatchUserAuthenticated,
                                                        }) => {
    const [loginIsWorking, setLoginIsWorking]: any = useState(false);
    const [loginErrorMessage, setLoginErrorMessage]: any = useState(false);
    const history = useHistory();
    const location = useLocation<any>();

    const [loginType, setLoginType]: string = useState<string>('');

    const path = (
        location.hasOwnProperty('state') &&
        location.state instanceof Object &&
        location.state.hasOwnProperty('from') &&
        location.state.from instanceof Object &&
        location.state.from.hasOwnProperty('pathname') &&
        location.state.from.pathname
    ) ? location.state.from.pathname : '/';
    const search = (
        location.hasOwnProperty('state') &&
        location.state instanceof Object &&
        location.state.hasOwnProperty('from') &&
        location.state.from instanceof Object &&
        location.state.from.hasOwnProperty('search') &&
        location.state.from.search
    ) ? location.state.from.search : '';
    const redirectUrl = '/p/flow' + path + search;

    const handleLogin = (formValues: LoginFormValues) => {
        setLoginIsWorking(true);
        setLoginErrorMessage('');

        Flow.getInstance().userLogin(formValues.email, formValues.password)
            .then((response: FlowFetchResponse) => {
                if (response.ok && response.json.token) {
                    console.log('setting', response.json);
                    User.getInstance().setEmail(response.json.user.email);
                    User.getInstance().setAuthToken(response.json.token);
                    User.getInstance().setRoles(response.json.user.roles);
                    dispatchUserAuthenticated();
                    console.log(location?.state?.from);
                    const path = (
                        location.hasOwnProperty('state') &&
                        location.state instanceof Object &&
                        location.state.hasOwnProperty('from') &&
                        location.state.from instanceof Object &&
                        location.state.from.hasOwnProperty('pathname') &&
                        location.state.from.pathname
                    ) ? location.state.from.pathname : '/';
                    const search = (
                        location.hasOwnProperty('state') &&
                        location.state instanceof Object &&
                        location.state.hasOwnProperty('from') &&
                        location.state.from instanceof Object &&
                        location.state.from.hasOwnProperty('search') &&
                        location.state.from.search
                    ) ? location.state.from.search : '';

                    history.push(path + search);
                } else {
                    setLoginErrorMessage(response.json.message || 'Error logging in');
                }
                setLoginIsWorking(false);
            })
            .catch((error: any) => {
                setLoginErrorMessage(error);
                setLoginIsWorking(false);
            });
    };

    return (
        <div id="login-page"
             className="text-center">
            <div id="login-page-inner">
                <div className="text-center">
                    <AppLogo className="app-logo" style={{width: '200px'}}/>
                    <h1 className="mb-5">Fletch</h1>
                </div>
                <div className={'d-flex justify-content-around align-items-center'}>
                    <a
                        href={`/sso/?ret=${redirectUrl}`}
                        className="btn btn-xl btn-outline-primary"
                        style={{ height: '56px', paddingTop: '.35rem'}}
                    >Employee Sign In using ABB SSO</a>
                </div>

                <h2 className="h3 mb-1 mt-5 font-weight-normal">Non-Employee Sign In with Email</h2>

                {loginErrorMessage &&
                    <p className="text-left alert alert-danger"><strong>Error!</strong> {loginErrorMessage}</p>}
                <LoginForm
                    isWorking={loginIsWorking}
                    onSubmit={handleLogin}
                />

            </div>
            <div style={{
                position: 'fixed',
                bottom: '15px',
                right: '15px',
            }}>
                <img className="mb-4"
                     src="https://s7d3.scene7.com/is/image/ThomasBetts/abb-logo?fmt=png-alpha&hei=72"
                     alt=""
                     height="52"
                />
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        dispatchUserAuthenticated: (): void => {
            dispatch(userAuthenticated());
        }
    };
};

const LoginConnected = connect(null, mapDispatchToProps)(Login);
export {LoginConnected as Login};
